module.exports = {
	"ha": "nha",
	"id": 2.1,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 815,
			"height": 430,
			"marginLeft": 155,
			"marginRight": 160,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 155px;\">Figure 2.1</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing for Northern Health and HSDA <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018,
					2019,
					2020,
					2021,
					2022
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 400,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -145
				}
			}
		],
		"series": [
			{
				"name": "Northeast",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2243.665992625193,
					2169.575317171958,
					2329.465671421181,
					2500.108448891652,
					2557.5520573165686,
					2405.1452375591084,
					2722.004742461871,
					2629.395801403282,
					2939.1487864931414,
					2986.3493174658734,
					2583.8027776228455,
					1698.1105726933768,
					2092.757022393477,
					{
						"y": 2640.093721235112,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northeast</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northern Interior",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2295.9075712048752,
					2372.152077308316,
					2462.6444882999717,
					3116.981715675592,
					3649.63503649635,
					4460.863285373034,
					4983.649985512646,
					4760.800469259416,
					5128.759716120311,
					5247.424331393797,
					5018.995803714441,
					3720.970102997613,
					3920.999320324924,
					{
						"y": 4062.1541866469934,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Interior</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northwest",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2037.4054914444887,
					2107.869379014989,
					2139.3560267554903,
					2421.9014704885817,
					2769.985974754558,
					2973.9230388815377,
					3192.487004983656,
					3388.855441835574,
					3558.067446956336,
					4105.2869708704275,
					4682.256572862993,
					3444.351420647795,
					3706.6787588261973,
					{
						"y": 3953.7954641607157,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 9,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northwest</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "All Northern Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": -1,
				"data": [
					2215.0341044933552,
					2254.570838298442,
					2346.5977860820285,
					2787.5664019355177,
					3156.6389933257046,
					3573.190378120677,
					3969.8283419683776,
					3891.9166569793288,
					4199.1499613773485,
					4413.094226072407,
					4348.525253608137,
					3167.093194353152,
					3429.9298166176136,
					{
						"y": 3695.952825526749,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">All Northern Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_2_1.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_2_1.json
// module id = 256
// module chunks = 0